var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "top_info"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Validators")]), _vm.theme ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "graph",
    staticStyle: {
      "height": "265px"
    },
    attrs: {
      "show": _vm.currentValidators
    }
  }, [_c('canvas', {
    ref: "validators_graph",
    staticClass: "validators_graph"
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "top_info"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Validators")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "show": _vm.currentValidators
    }
  }, [_c('canvas', {
    ref: "validators_graph",
    staticClass: "validators_graph"
  })]), _vm.currentValidators ? _c('div', {
    staticClass: "validator_list"
  }, [_c('ValidatorDataTable', {
    attrs: {
      "validators": _vm.currentValidators
    }
  })], 1) : _c('Loader', {
    attrs: {
      "message": "Loading graph",
      "content-id": ""
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }